(function () {
  'use strict';
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var AY = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  /* ---------- Türkiye saatine göre takvim yardımcıları ---------- */
  function trNow() {
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return { d: new Date(+o.year, +o.month - 1, +o.day), h: +o.hour % 24 };
    } catch (e) { var n = new Date(); return { d: new Date(n.getFullYear(), n.getMonth(), n.getDate()), h: n.getHours() }; }
  }
  function key(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function isWork(d, hol) { var w = d.getDay(); return w !== 0 && w !== 6 && hol.indexOf(key(d)) < 0; }
  function addWork(d, k, hol) { var x = new Date(d.getTime()); while (k > 0) { x.setDate(x.getDate() + 1); if (isWork(x, hol)) k--; } return x; }
  function fmtRange(a, b) {
    if (a.getTime() === b.getTime()) return a.getDate() + ' ' + AY[a.getMonth()];
    return a.getMonth() === b.getMonth() ? a.getDate() + '–' + b.getDate() + ' ' + AY[b.getMonth()] : a.getDate() + ' ' + AY[a.getMonth()] + ' – ' + b.getDate() + ' ' + AY[b.getMonth()];
  }
  function eta(box) {
    var k = box.querySelector('[data-eta-k]'), v = box.querySelector('[data-eta]');
    var mn = parseInt(box.getAttribute('data-min') || '2', 10), mx = parseInt(box.getAttribute('data-max') || '3', 10);
    var cut = parseInt(box.getAttribute('data-cutoff') || '15', 10);
    var hol = (box.getAttribute('data-holidays') || '').split(',');
    var n = trNow(), sameDay = isWork(n.d, hol) && n.h < cut;
    /* işleme günü: bugün (kesim saatinden önce ve iş günüyse) ya da sonraki ilk iş günü */
    var base = sameDay ? n.d : addWork(n.d, 1, hol);
    var a = addWork(base, mn, hol), b = addWork(base, mx, hol);
    if (v) v.textContent = fmtRange(a, b);
    if (k) k.textContent = sameDay ? 'Saat ' + cut + ':00’e kadar sipariş verirseniz tahmini teslim' : 'Şimdi sipariş verirseniz tahmini teslim';
  }

  /* ---------- Sepet sayacı ve bildirim ---------- */
  var toastT;
  function toast(html) {
    var t = document.querySelector('[data-ds-toast]'); if (!t) return;
    t.innerHTML = html; t.hidden = false; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.hidden = true; }, 300); }, 5000);
    var c = t.querySelector('[data-close]'); c && c.addEventListener('click', function () { t.classList.remove('is-on'); t.hidden = true; });
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (e) { e.textContent = n; });
    $$('[data-cart-link]').forEach(function (e) { e.setAttribute('aria-label', 'Sepet, ' + n + ' ürün'); });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function ajaxAdd(form, submitter) {
    if (submitter && submitter.hasAttribute('data-buynow')) return false;
    if (!window.fetch || !window.FormData) return false;
    var fd = new FormData(form); fd.delete('return_to');
    var btns = $$('button[type=submit]', form).concat(form.id ? $$('button[form="' + form.id + '"]') : []);
    var was = btns.map(function (b) { return b.disabled; });
    btns.forEach(function (b) { b.disabled = true; b.classList.add('is-busy'); });
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast('<span>' + esc(res.j.description || res.j.message || 'Ürün sepete eklenemedi.') + '</span><button type="button" data-close aria-label="Kapat">×</button>'); return; }
        var title = (res.j.product_title || res.j.title || '').split(' – ')[0];
        toast('<span><b>Sepete eklendi</b>' + esc(title) + '</span><a class="ds-btn ds-btn--red" href="/cart">Sepete git</a><button type="button" data-close aria-label="Kapat">×</button>');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function () { form.submit(); })
      .then(function () { btns.forEach(function (b, k) { b.classList.remove('is-busy'); b.disabled = was[k]; }); });
    return true;
  }

  function init() {
    /* ---------- Yelpaze karusel ---------- */
    $$('[data-ds-fan]').forEach(function (st) {
      var cards = $$('.ds-card', st), dots = $$('[data-dot]', st), play = st.querySelector('[data-play]'), n = cards.length, i = 0, hover = false, stopped = rm || window.matchMedia('(max-width: 760px)').matches;
      var initialDraw = true;
      var iv = parseInt(st.getAttribute('data-interval') || '5000', 10) || 5000;
      if (!n) return;
      var cfg = { 0: [0, 1, 5, 1, 'none', '0 30px 60px rgba(40,30,20,.28)'], 1: [230, .76, 4, 1, 'none', '0 18px 36px rgba(40,30,20,.18)'], '-1': [-230, .76, 4, 1, 'none', '0 18px 36px rgba(40,30,20,.18)'], 2: [385, .6, 3, .5, 'saturate(.6)', 'none'], '-2': [-385, .6, 3, .5, 'saturate(.6)', 'none'] };
      function draw() {
        cards.forEach(function (c, k) {
          if (initialDraw) c.style.transition = 'none';
          var r = ((k - i) % n + n) % n; if (r > n / 2) r -= n;
          var f = cfg[String(r)] || [0, .5, 1, 0, 'none', 'none'];
          c.style.transform = 'translate(-50%,-50%) translateX(' + f[0] + 'px) scale(' + f[1] + ')';
          c.style.zIndex = f[2]; c.style.opacity = f[3]; c.style.filter = f[4]; c.style.boxShadow = f[5];
          var image = c.querySelector('img');
          if (r === 0 && image) image.sizes = '(max-width: 760px) 210px, 340px';
          c.classList.toggle('is-c', r === 0); c.setAttribute('tabindex', Math.abs(r) <= 1 ? '0' : '-1');
          c.setAttribute('aria-hidden', Math.abs(r) <= 1 ? 'false' : 'true');
        });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function go(k) { i = (k + n) % n; draw(); }
      cards.forEach(function (c, k) { c.addEventListener('click', function (e) { if (k !== i) { e.preventDefault(); go(k); } }); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { st.addEventListener(ev, function () { hover = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { st.addEventListener(ev, function () { hover = false; }); });
      function setPlay() {
        if (!play) return;
        play.setAttribute('aria-label', stopped ? 'Otomatik geçişi başlat' : 'Otomatik geçişi durdur');
        play.querySelector('[data-i=pause]').style.display = stopped ? 'none' : '';
        play.querySelector('[data-i=play]').style.display = stopped ? '' : 'none';
      }
      play && play.addEventListener('click', function () { stopped = !stopped; hover = false; setPlay(); });
      setPlay(); draw();
      requestAnimationFrame(function () { requestAnimationFrame(function () { cards.forEach(function (c) { c.style.transition = ''; }); initialDraw = false; }); });
      setInterval(function () { if (!hover && !stopped && !document.hidden) go(i + 1); }, iv);
    });

    /* ---------- Filtre çipleri ---------- */
    $$('[data-ds-filter]').forEach(function (w) {
      var chips = $$('[data-f]', w), items = $$('[data-tags]', w), cnt = w.querySelector('[data-count]');
      function apply(f) {
        var c = 0;
        chips.forEach(function (ch) { ch.setAttribute('aria-pressed', ch.getAttribute('data-f') === f ? 'true' : 'false'); });
        items.forEach(function (it) { var ok = f === 'all' || (' ' + it.getAttribute('data-tags') + ' ').indexOf(' ' + f + ' ') > -1; it.hidden = !ok; if (ok) c++; });
        if (cnt) cnt.textContent = c;
      }
      function keep(f) { try { var u = new URL(location.href); if (f === 'all') u.searchParams.delete('filtre'); else u.searchParams.set('filtre', f); history.replaceState(null, '', u.toString()); } catch (e) {} }
      chips.forEach(function (ch) { ch.addEventListener('click', function () { var f = ch.getAttribute('data-f'); if (ch.getAttribute('aria-pressed') === 'true' && f !== 'all') f = 'all'; apply(f); keep(f); }); });
      var f0 = new URL(location.href).searchParams.get('filtre');
      if (f0 && chips.some(function (ch) { return ch.getAttribute('data-f') === f0; })) apply(f0);
    });

    /* ---------- Renk seçici (öne çıkan ürün) ---------- */
    $$('[data-ds-swatch]').forEach(function (w) {
      var bs = $$('[data-sw]', w), im = w.querySelector('[data-sw-img] img'), nm = $$('[data-sw-name]', w), pr = $$('[data-sw-price]', w), lk = $$('[data-sw-link]', w), id = w.querySelector('[data-sw-id]'), btn = w.querySelector('[data-sw-btn]');
      bs.forEach(function (b) {
        b.addEventListener('click', function () {
          bs.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
          if (im && b.dataset.img) { im.removeAttribute('srcset'); im.src = b.dataset.img; }
          nm.forEach(function (e) { e.textContent = b.dataset.name; });
          pr.forEach(function (e) { e.textContent = b.dataset.price; });
          lk.forEach(function (a) { a.href = b.dataset.url; });
          if (id) id.value = b.dataset.id;
          if (btn) { var ok = b.dataset.avail !== 'false'; btn.disabled = !ok; ok ? btn.removeAttribute('data-off') : btn.setAttribute('data-off', ''); }
        });
      });
    });

    /* ---------- Ürün sayfası ---------- */
    $$('[data-ds-product]').forEach(function (p) {
      var vj = p.querySelector('[data-variants]'), vs = vj ? JSON.parse(vj.textContent) : [];
      var imgs = $$('.ds-main img', p), th = $$('.ds-thumb', p), cur = 0, idIn = p.querySelector('form [name=id]');
      var prc = $$('[data-price]', p), cmp = p.querySelector('[data-compare]'), sku = p.querySelector('[data-sku]');
      var stk = p.querySelector('[data-stock]'), pill = p.querySelector('.ds-stock'), opts = $$('.ds-opt', p), cnt = p.querySelector('[data-img-n]');
      var box = p.querySelector('[data-eta-box]'), etaV = box && box.querySelector('[data-eta]'), etaK = box && box.querySelector('[data-eta-k]'), etaN = box && box.querySelector('[data-eta-n]'), etaN0 = etaN ? etaN.textContent : '';
      function show(k) {
        if (!imgs.length) return;
        cur = (k + imgs.length) % imgs.length;
        imgs.forEach(function (m, j) { m.classList.toggle('is-on', j === cur); });
        th.forEach(function (t, j) { t.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
        if (cnt) cnt.textContent = (cur + 1) + ' / ' + imgs.length;
      }
      th.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
      var pv = p.querySelector('[data-prev]'), nx = p.querySelector('[data-next]');
      pv && pv.addEventListener('click', function () { show(cur - 1); });
      nx && nx.addEventListener('click', function () { show(cur + 1); });
      function state(v) {
        if (!v.available) return 'out';
        if (v.tracked && v.qty <= 0) return 'pre';
        if (v.tracked && v.deny && v.qty <= 10) return 'low';
        return 'ok';
      }
      function paintEta(s) {
        if (!box) return;
        box.hidden = s === 'out';
        if (s === 'pre') {
          if (etaK) etaK.textContent = 'Bu seçenek şu an stokta yok';
          if (etaV) etaV.textContent = 'Kargo tarihi sipariş onayıyla bildirilir';
          if (etaN) etaN.textContent = 'Bilgi için WhatsApp’tan yazabilirsiniz';
        } else if (s !== 'out') { if (etaN) etaN.textContent = etaN0; eta(box); }
      }
      function sel() { return opts.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; }); }
      function upd() {
        var s = sel(), v = null;
        vs.forEach(function (x) { if (!v && x.options.every(function (o, j) { return o === s[j]; })) v = x; });
        opts.forEach(function (f, j) { var l = f.querySelector('[data-sel]'); if (l) l.textContent = s[j] || ''; });
        if (!v) {
          $$('[data-add],[data-buynow]', p).forEach(function (b) { b.disabled = true; var l = b.querySelector('[data-label]'); if (l) l.textContent = 'Bu seçenek yok'; });
          return;
        }
        if (idIn) idIn.value = v.id;
        prc.forEach(function (e) { e.textContent = v.price; });
        if (cmp) { cmp.textContent = v.compare || ''; cmp.hidden = !v.compare; }
        if (sku) { sku.textContent = v.sku || ''; sku.hidden = !v.sku; }
        var st = state(v);
        if (pill) pill.setAttribute('data-state', st);
        if (stk) stk.textContent = { out: 'Tükendi', pre: 'Siparişe açık', low: 'Stokta · son ' + v.qty + ' adet', ok: 'Stokta' }[st];
        $$('[data-add]', p).forEach(function (b) { b.disabled = !v.available; var l = b.querySelector('[data-label]'); if (l) l.textContent = v.available ? 'Sepete ekle' : 'Tükendi'; });
        $$('[data-buynow]', p).forEach(function (b) { b.disabled = !v.available; });
        paintEta(st);
        if (v.img >= 0) show(v.img);
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) { }
      }
      opts.forEach(function (f) { f.addEventListener('change', upd); });
      var q = p.querySelector('[data-qty]');
      if (q) {
        var qi = q.querySelector('input');
        q.querySelector('[data-dec]').addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); });
        q.querySelector('[data-inc]').addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; });
      }
      var bn = p.querySelector('[data-buynow]'), rt = p.querySelector('form [name=return_to]');
      bn && rt && bn.addEventListener('click', function () { rt.value = '/cart#odeme'; });
      var st0 = 0; imgs.forEach(function (m, j) { if (m.classList.contains('is-on')) st0 = j; }); show(st0);
      paintEta(pill ? pill.getAttribute('data-state') : 'ok');
      /* Mobil alt çubuk: ana buton ekrandayken gizle */
      var mbar = p.querySelector('[data-mbar]'), main = p.querySelector('[data-main-add]');
      if (mbar && main && 'IntersectionObserver' in window) {
        mbar.classList.add('is-hidden');
        new IntersectionObserver(function (en) { en.forEach(function (e) { var below = e.boundingClientRect.top > window.innerHeight; mbar.classList.toggle('is-hidden', e.isIntersecting || below); }); }).observe(main);
      }
    });
    $$('[data-eta-box]').forEach(function (b) { if (!b.closest('[data-ds-product]')) eta(b); });

    /* ---------- AJAX sepete ekle ---------- */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('form[data-ds-add]')) return;
      if (ajaxAdd(f, e.submitter)) e.preventDefault();
    });

    /* ---------- Sepet sayfası ---------- */
    $$('[data-ds-cart]').forEach(function (f) {
      $$('[data-q]', f).forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = f.querySelector('[data-upd="' + b.getAttribute('data-q') + '"]');
          if (!inp) return;
          inp.value = Math.max(0, parseInt(b.getAttribute('data-v'), 10) || 0);
          f.classList.add('is-busy'); f.submit();
        });
      });
      var inv = f.querySelector('[data-ds-inv]'), typ = f.querySelector('[data-inv-type]'), corp = $$('[data-corp]', f), vkn = f.querySelector('[data-vkn]'), ierr = f.querySelector('[data-inv-err]');
      var cons = f.querySelector('[data-consent]'), ctime = f.querySelector('[data-consent-time]'), cerr = f.querySelector('[data-consent-err]');
      var acceptedAt = '';
      function resetConsent() {
        acceptedAt = '';
        if (cons) { cons.checked = false; cons.defaultChecked = false; }
        if (ctime) ctime.value = '';
        if (cerr) cerr.hidden = true;
      }
      resetConsent();
      window.addEventListener('pageshow', resetConsent);
      window.addEventListener('pagehide', resetConsent);
      function syncInv() { if (typ && inv) typ.value = inv.open ? 'Kurumsal' : 'Bireysel'; }
      inv && inv.addEventListener('toggle', syncInv); syncInv();
      vkn && vkn.addEventListener('input', function () { vkn.value = vkn.value.replace(/\D/g, '').slice(0, 11); });
      cons && cons.addEventListener('change', function () { acceptedAt = cons.checked ? new Date().toISOString() : ''; if (ctime) ctime.value = acceptedAt; if (cerr && cons.checked) cerr.hidden = true; });
      f.addEventListener('submit', function (e) {
        var s = e.submitter; if (!s || s.name !== 'checkout') return;
        var ok = true, msg = '';
        if (inv && inv.open) {
          corp.forEach(function (i) { i.removeAttribute('aria-invalid'); if (!i.value.trim()) { ok = false; i.setAttribute('aria-invalid', 'true'); msg = 'Kurumsal fatura için tüm alanları doldurun.'; } });
          if (ok && vkn && !/^\d{10,11}$/.test(vkn.value)) { ok = false; vkn.setAttribute('aria-invalid', 'true'); msg = 'Vergi numarası 10 haneli (VKN) veya 11 haneli (T.C. kimlik no) olmalı.'; }
          if (ierr) { ierr.textContent = msg; ierr.hidden = ok; }
          if (!ok) { e.preventDefault(); inv.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' }); return; }
        }
        if (!cons || !cons.checked || !acceptedAt) { e.preventDefault(); if (cerr) cerr.hidden = false; if (cons) cons.focus(); return; }
        if (ctime) ctime.value = acceptedAt;
      });
      if (location.hash === '#odeme' && cons) { setTimeout(function () { var a = document.getElementById('odeme'); a && a.scrollIntoView({ block: 'start' }); cons.focus({ preventScroll: true }); }, 50); }
    });

    /* ---------- Sıralama ---------- */
    $$('[data-ds-sort]').forEach(function (s) { s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); }); });

    /* ---------- Canlı arama ---------- */
    $$('[data-ds-live]').forEach(function (form) {
      var inp = form.querySelector('input[name=q]'), box = form.querySelector('[data-ds-live-res]'), tm, ctrl, last = '';
      if (!inp || !box) return;
      var money = function (v) { var n = Number(v); return isNaN(n) ? v : n.toLocaleString('tr-TR', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' TL'; };
      var esc = function (t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      function close() { box.hidden = true; inp.setAttribute('aria-expanded', 'false'); }
      function run() {
        var q = inp.value.trim();
        if (q.length < 2) { box.innerHTML = ''; close(); return; }
        if (q === last) { box.hidden = false; return; }
        last = q; if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            var h = ps.length ? ps.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
              return '<a role="option" class="ds-live__i" href="' + esc(p.url.split('?')[0]) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="ds-live__ph"></span>') +
                '<span class="ds-live__t"><b>' + esc(p.title) + '</b><small>' + money(p.price) + (p.available ? '' : ' · Tükendi') + '</small></span></a>';
            }).join('') + '<a class="ds-live__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">“' + esc(q) + '” için tüm sonuçlar</a>'
              : '<p class="ds-live__no">“' + esc(q) + '” için ürün bulunamadı. Farklı bir kelime deneyin.</p>';
            box.innerHTML = h; box.hidden = false; inp.setAttribute('aria-expanded', 'true');
          }).catch(function () {});
      }
      inp.addEventListener('input', function () { clearTimeout(tm); tm = setTimeout(run, 220); });
      inp.addEventListener('focus', function () { if (box.innerHTML && inp.value.trim().length > 1) { box.hidden = false; } });
      inp.addEventListener('keydown', function (e) {
        var items = $$('a', box), i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && items.length) { e.preventDefault(); items[0].focus(); }
        if (e.key === 'Escape') close();
      });
      box.addEventListener('keydown', function (e) {
        var items = $$('a', box), i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); i > 0 ? items[i - 1].focus() : inp.focus(); }
        if (e.key === 'Escape') { close(); inp.focus(); }
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
    $$('[data-ds-sopen]').forEach(function (b) {
      var pnl = document.getElementById(b.getAttribute('aria-controls'));
      if (!pnl) return;
      function set(o) { pnl.hidden = !o; b.setAttribute('aria-expanded', o ? 'true' : 'false'); if (o) { var i = pnl.querySelector('input[name=q]'); i && i.focus(); } }
      b.addEventListener('click', function (e) { e.preventDefault(); set(pnl.hidden); });
      pnl.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); b.focus(); } });
      $$('[data-ds-sclose]', pnl).forEach(function (c) { c.addEventListener('click', function () { set(false); b.focus(); }); });
    });

    /* ---------- Mobil menü ---------- */
    $$('.ds-mnav').forEach(function (d) {
      document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) { d.open = false; d.querySelector('summary').focus(); } });
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

